import Vue from 'vue'
import Router from 'vue-router'

// global
import ShareReport from '@/components/ShareReport'
import NotFound from '@/components/global/NotFound'
import AppMaintenance from '@/components/global/AppMaintenance'
import Term from '@/components/global/term/Term'
import PrivacyEurope from '@/components/global/term/PrivacyEurope'
import PrivacyGlobal from '@/components/global/term/PrivacyGlobal'

// guest
import Guest from '@/components/guest'
import SignIn from '@/components/guest/SignIn'
import SignUp from '@/components/guest/SignUp'
import RecoverPassword from '@/components/guest/RecoverPassword'
import ResetPassword from '@/components/guest/ResetPassword'

// member
import Member from '@/components/member'
import AccountStatus from '@/components/member/AccountStatus'

// valid member
import ValidMember from '@/components/valid-member'
import MyPage from '@/components/valid-member/MyPage'
import AppGuide from '@/components/valid-member/AppGuide'
import Dashboard from '@/components/valid-member/dashboard'
import Report from '@/components/valid-member/report'
import ReportDocument from '@/components/valid-member/report/ReportDocument'

// admin
import Admin from '@/components/admin'
import AdminHome from '@/components/admin/AdminHome'

import appDataApi from '@/api/app-data'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: {
        name: 'Main'
      }
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Term
    },
    {
      path: '/privacy/europe',
      name: 'PrivacyEurope',
      component: PrivacyEurope
    },
    {
      path: '/privacy/global',
      name: 'PrivacyGlobal',
      component: PrivacyGlobal
    },
    {
      path: '/report/share/:token',
      name: 'SharedReport',
      component: ShareReport
    },
    {
      path: '/report/share/:token/:deviceType',
      name: 'SharedReportWithDevice',
      component: ShareReport
    },
    {
      path: '/guest',
      component: Guest,
      children: [
        {
          path: '/signin',
          name: 'SignIn',
          component: SignIn
        },
        {
          path: '/signup',
          name: 'SignUp',
          component: SignUp
        },
        {
          path: '/recover-password',
          name: 'RecoverPassword',
          component: RecoverPassword
        },
        {
          path: '/reset-password/:token',
          name: 'ResetPassword',
          component: ResetPassword
        }
      ],
      beforeEnter: (to, from, next) => {
        appDataApi.authStatus().then(response => {
          const data = response.data

          if (data) {
            console.log('already logined')

            if (data.roleCode === 1 || data.statusCode === 1) {
              return next({ name: 'Main' })
            } else {
              return next({ name: 'AccountStatus' })
            }
          }
          next()
        }).catch(err => {
          console.error(err)
          next(false)
        })
      }
    },
    {
      path: '/member',
      component: Member,
      children: [
        {
          path: '/account/status',
          name: 'AccountStatus',
          component: AccountStatus
        }
      ],
      beforeEnter: (to, from, next) => {
        appDataApi.authStatus().then(response => {
          const data = response.data

          if (!data) {
            console.log('login required')
            return next({ name: 'SignIn' })
          }
          next()
        }).catch(err => {
          console.error(err)
          next(false)
        })
      }
    },
    {
      path: '/valid-member',
      component: ValidMember,
      children: [
        {
          path: '/account/mypage',
          name: 'MyPage',
          component: MyPage
        },
        {
          path: '/dashboard',
          name: 'Main',
          component: Dashboard
        },
        {
          path: '/guide',
          name: 'AppGuide',
          component: AppGuide
        },
        {
          path: '/report/view/:id',
          name: 'ReportDocument',
          component: ReportDocument
        },
        {
          path: '/report/temp/:id',
          name: 'TempReport',
          component: Report
        },
        {
          path: '/report/:id',
          name: 'Report',
          component: Report
        }
      ],
      beforeEnter: (to, from, next) => {
        appDataApi.authStatus().then(response => {
          const data = response.data

          if (!data) {
            console.log('login required')
            return next({ name: 'SignIn' })
          } else {
            if (data.roleCode !== 1 && data.statusCode !== 1) {
              console.log('unauthorized')
              return next({ name: 'AccountStatus' })
            }
          }
          next()
        }).catch(err => {
          console.error(err)
          next(false)
        })
      }
    },
    {
      path: '/admin',
      component: Admin,
      children: [
        {
          path: 'approval',
          name: 'ManageApproval',
          component: AdminHome
        },
        {
          path: 'user',
          name: 'ManageUser',
          component: AdminHome
        },
        {
          path: 'report',
          name: 'ManageReport',
          component: AdminHome
        }
      ],
      beforeEnter: (to, from, next) => {
        appDataApi.authStatus().then(response => {
          const data = response.data

          if (!data) {
            console.log('login required')
            return next({ name: 'SignIn' })
          } else {
            if (data.roleCode === 1) {
              return next()
            } else {
              console.log('unauthorized')
              if (data.statusCode === 1) {
                return next({ name: 'Main' })
              } else {
                return next({ name: 'AccountStatus' })
              }
            }
          }
        }).catch(err => {
          console.error(err)
          next(false)
        })
      }
    },
    {
      path: '/maintenance',
      name: 'AppMaintenance',
      component: AppMaintenance
    },

    {
      path: '*',
      name: 'NotFound',
      component: NotFound
    }

  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js